import { CustomProperty, CustomPropertyType } from "winslow-core";
import "./AppCustomProperty.css";
import { AppCustomPropertyShort } from "./AppCustomPropertyShort";
import { AppCustomPropertyLong } from "./AppCustomPropertyLong";
import { AppCustomPropertyDropdown } from "./AppCustomPropertyDropdown";
import { AppCustomPropertyCheckboxSingle } from "./AppCustomPropertyCheckboxSingle";
import { AppCustomPropertyCheckboxMultiple } from "./AppCustomPropertyCheckboxMultiple";
import { AppCustomPropertyRadio } from "./AppCustomPropertyRadio";
import { AppCustomPropertyRich } from "./AppCustomPropertyRich";
import { AppCustomPropertyPhone } from "./AppCustomPropertyPhone";
import { AppCustomPropertyNumber } from "./AppCustomPropertyNumber";
import { AppCustomPropertyDate } from "./AppCustomPropertyDate";
import { AppCustomPropertyFile } from "./AppCustomPropertyFile";
import { AppCustomPropertyEmployeeRecord } from "./AppCustomPropertyEmployeeRecord";
import { AppCustomPropertyEmail } from "./AppCustomPropertyEmail";
import { AppCustomPropertyPTOPolicies } from "./AppCustomPropertyPTOPolicies";

type AppCustomPropertyProps = {
    customProperty: CustomProperty;
    data: any;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomProperty = ({customProperty, data, validate, onChange} : AppCustomPropertyProps) => {

    return (
        <div className="app-custom-property">
           {(() => {
                switch (customProperty.type) {
                    case CustomPropertyType.SHORT:
                        return (
                            <AppCustomPropertyShort
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.LONG:
                        return (
                            <AppCustomPropertyLong
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.DATE:
                        return (
                            <AppCustomPropertyDate
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.NUMBER:
                        return (
                            <AppCustomPropertyNumber
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.EMAIL:
                        return (
                            <AppCustomPropertyEmail
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.EMPLOYEE_RECORD:
                        return (
                            <AppCustomPropertyEmployeeRecord
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.PTO_POLICIES:
                        return (
                            <AppCustomPropertyPTOPolicies
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );    
                    case CustomPropertyType.DROPDOWN:
                        return (
                            <AppCustomPropertyDropdown
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.CHECKBOX_MULTIPLE:
                        return (
                            <AppCustomPropertyCheckboxMultiple
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.CHECKBOX_SINGLE:
                        return (
                            <AppCustomPropertyCheckboxSingle
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.FILE:
                        return (
                            <AppCustomPropertyFile
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.PHONE:
                        return (
                            <AppCustomPropertyPhone
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.RICH:
                        return (
                            <AppCustomPropertyRich
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    case CustomPropertyType.RADIO:
                        return (
                            <AppCustomPropertyRadio
                                customProperty={customProperty}
                                data={data}
                                validate={validate}
                                onChange={onChange}
                            />
                        );
                    default:
                        return (
                            <div>
                                Type: {customProperty.type}
                            </div>
                        );
                    }
                }
            )()
            }           
        </div>
    )
}